import React from 'react';
function Login(props) {
    return (
        <>
        Admin Login Page
        </>
    )
}
export default Login;